import { render } from "./StockSearchFormPage.vue?vue&type=template&id=72163f74"
import script from "./StockSearchFormPage.vue?vue&type=script&lang=js"
export * from "./StockSearchFormPage.vue?vue&type=script&lang=js"

import "./StockSearchFormPage.vue?vue&type=style&index=0&id=72163f74&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__